import { render, staticRenderFns } from "./OnboardingForm.vue?vue&type=template&id=c1196ac2&scoped=true&"
import script from "./OnboardingForm.vue?vue&type=script&lang=js&"
export * from "./OnboardingForm.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingForm.vue?vue&type=style&index=0&id=c1196ac2&lang=scss&scoped=true&"
import style1 from "./OnboardingForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1196ac2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
